// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"30c722c4ca0b25e48133","453":"3518c36e23623a816fd3"}[chunkId] + ".js";
};